import { combineReducers } from "redux";
import authReducer from "./authReducer";
import profileReducer from "./profileReducer";
import settingsReducer from "./settingsReducer";
import projectReducer from "./projectReducer";
import assetReducer from "./assetReducer";

export default combineReducers({
  auth: authReducer,
  profile: profileReducer,
  settings: settingsReducer,
  project: projectReducer,
  asset: assetReducer
});
